export const CLINICS_LEADS_COLLECTION = "clinicLeads";
export const ADMIN_CLINICS_COLLECTION = "adminClinicsV2";
export const ADMIN_ORDER_COLLECTION = "adminOrdersV2";
export const ORDER_PERMISSIONS_COLLECTION = "order_permissions";
export const ANNOUNCEMENT_POPUPS_COLLECTION = "announcementPopups";
export const HARDWARE_VISIT_REQUESTS_COLLECTION = "hardwareVisitRequests";
export const HARDWARE_VISIT_DRAFTS_COLLECTION = "hardwareVisitDrafts";
export const BULK_CLINIC_MESSAGES_COLLECTION = "bulkClinicMessages";

/**
 * client 챗봇 운영 설정. 문서 하나만 쓴다 — 치과별 설정은 그 문서 안의 map 이다.
 * 치과 수만큼 문서를 만들면 clinic-client 가 자기 설정 하나를 읽는 대신 목록을
 * 조회해야 하고, admin 화면도 "지금 누가 켜져 있나"를 한 번에 못 본다.
 */
export const CHATBOT_SETTINGS_COLLECTION = "chatbotSettings";
export const CHATBOT_ROLLOUT_DOCUMENT_ID = "clientRollout";
